<template>
    <div>
        <b-button id="report_problem" variant="danger" style="font-family: Verdana, sans-serif" v-on:click="showModal=true">
            <i class="mr-3 float-left fa-solid fa-1x fa-exclamation-circle"></i><div> Report Problem</div>
        </b-button><validation-observer ref="observer" v-slot="{ passes, invalid }">

        <b-modal title="Technology Issue" id="tech issue" ok-title="Ok"
                 v-model="showModal"
                 :ok-disabled="invalid"
                 :busy="isBusy"
                 @ok="handleOk">
            <b-form>
                <validation-provider
                        name="Problem"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                >
                    <b-form-group
                            id="input-group-brand"
                            label="Type of Problem:"
                            label-for="input-brand"
                    >
                        <b-form-select v-model="option_selected" :options="options" id="input-option"
                                       :state="getValidationState(validationContext)"
                        ></b-form-select>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                        name="Tracking Number"
                        :rules="{ required: true }"
                        immediate
                        v-slot="validationContext"
                >
                    <b-form-group
                            id="input-group-tracking"
                            label="Brief Description:"
                            label-for="input-tracking-number"
                    >
                        <b-form-textarea
                            v-model="explanation"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </validation-provider>
            </b-form>
        </b-modal>
    </validation-observer>
    </div>
</template>

<script>
    export default {
        name: "TechnologyIssue",
        data() {
            return {
                showModal: false,
                options: [
                    {
                        label: 'Performance',
                        options: [
                            { value: 'Unresponsive (page not responding at all)', text: 'Unresponsive (page not responding at all)' },
                            { value: 'General Slowness (all pages)', text: 'General Slowness (all pages)' },
                            { value: 'Specific Slowness (one function)', text: 'Specific Slowness (one function)' },
                        ]
                    },
                    {
                        label: 'Miscalculation',
                        options: [
                            { value: 'Refresh required to see changes', text: 'Refresh required to see changes' },
                            { value: 'Changes won\'t save', text: 'Changes won\'t save' },
                            { value: 'Weight doesn\'t match', text: 'Weight doesn\'t match' },
                            { value: 'Incorrect total', text: 'Incorrect total' },
                            { value: 'Status mismatch', text: 'Status Mismatch' },
                            { value: 'Bagging issue', text: 'Bagging issue' },
                            { value: 'Missing records', text: 'Missing records' },
                            { value: 'Duplicate records', text: 'Duplicate records' },
                            { value: 'Offer/payment miscalculation', text: 'Offer/payment miscalculation' },
                        ]
                    },
                    {
                        label: 'Access/Permissions',
                        options: [
                            { value: 'Missing section/module/page', text: 'Missing section/module/page' },
                            { value: 'Cannot perform function', text: 'Cannot perform function' },
                            { value: 'Override not working', text: 'Override not working' },
                        ]
                    },
                    {
                        label: 'Errors',
                        options: [
                            { value: 'Video Failure (black screen)', text: 'Video Failure (black screen)' },
                            { value: 'Explicit error message', text: 'Explicit error message' },
                            { value: 'Broken page', text: 'Broken page' },
                            { value: 'Layout problem', text: 'Layout problem' },
                        ]
                    },
                    {
                        label: 'Other',
                        options: [
                            { value: 'Other', text: 'Other' },
                            { value: 'Buy-site problem', text: 'Buy-site problem' },
                            { value: 'Print Manager', text: 'Print Manager' },
                            { value: 'Email', text: 'Email' },
                            { value: 'Five9', text: 'Five9' },
                            { value: 'Reporting', text: 'Reporting' },
                            { value: 'Feature request', text: 'Feature request' },
                        ]
                    },
                ],
                option_selected: null,
                explanation: "",
                isBusy: false,
            };
        },
        methods: {
            handleOk() {
                let payload = {
                    issue: this.option_selected,
                    explanation: this.explanation,
                };
                if(this.$store.getters.activeOrder){
                    payload.order_id = this.$store.getters.activeOrder.id;
                }
                this.isBusy = true;
                this.$http.post('/reportIssue', payload).then(e=>{
                    this.showModal = false;
                    this.isBusy = false;
                    console.log(e);
                    if (e.data.data.id) {
                        this.$store.commit('commitFlag', e.data.data);
                    }
                });
            },
            getValidationState({dirty, validated, valid = null}) {
                return dirty || validated ? valid : null;
            },
        }
    }
</script>

<style scoped>
    #report_problem {
        border-radius: 14px;
        -webkit-transition: width 1s ease;
        -moz-transition: width 1s ease;
        -o-transition: width 1s ease;
        -ms-transition: width 1s ease;
        transition: width 1s ease;
        overflow: hidden !important;
        width: 40px;
    }

    #report_problem {
        height: 32px !important;
        overflow: hidden !important;
        white-space: nowrap !important;
        display: flex;
        flex-direction: row;
    }

    #report_problem span {
        height: 32px !important;
        overflow: hidden !important;
        white-space: nowrap !important;
    }

    #report_problem:hover {
        width: 175px;
        overflow: hidden !important;
        white-space: nowrap !important;
    }
    #report_problem i {
        margin-top: 2px;
    }
</style>